import { merge } from 'lodash'
import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  POST_OTP_SUCCESS,
  POST_DETAILS_SUCCESS,
  VIEW_AS_ADMIN_SUCCESS,
  SEND_VERIFICATION_SUCCESS,
  SHOW_RESEND
} from '../actions/login-actions'

export default (state = {}, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
    case POST_OTP_SUCCESS:
    case POST_DETAILS_SUCCESS:
      return merge({}, state, {
        user: action.user
      })
    case SEND_VERIFICATION_SUCCESS:
      return merge({}, state, {
        msg: action.msg
      })
    case SHOW_RESEND:
      return merge({}, state, {
        showResendBlock: true
      })
    default:
      return state

  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/user.js